import React from 'react';
import { Input, QuestionMark, SubmitButton, InputWrapper } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { ButtonWrapper, Information, ErrorMessage } from '../Elements';
import { PostCodeHelp } from '../Help';
import usePostcode from './hooks/usePostcode';
import { FlowEnum, ComponentsEnum } from '../../types';
import { MainLayout } from '../MainLayout';

interface Props {
  nextUrl: string;
  progress?: number;
  flow?: FlowEnum;
}

const Postcode: React.FC<Props> = (props: Props) => {
  const { nextUrl, progress, flow } = props;
  const { classes, t, pageTitle, title, handleSubmit, register, errors, toggleHelpModal } = usePostcode(nextUrl);

  const { ref, name, onChange, onBlur } = register('postcode', {
    required: { value: true, message: t('validation_postcode') },
    pattern: { value: /[\d]{5}/, message: t('validation_postcode_format') },
    maxLength: { value: 5, message: t('validation_postcode_format') },
  });
  return (
    <MainLayout
      navigationId={ComponentsEnum.POST_CODE}
      flow={flow}
      progress={progress}
      directAccess={false}
      t={t}
      pageTitle={pageTitle}
    >
      <HelpModal>
        <PostCodeHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <QuestionMark onHelpClick={toggleHelpModal} title={t(title)}>
          <InputWrapper>
            <div className="errorWrapper">
              <Input
                onBlur={onBlur}
                onChange={onChange}
                name={name}
                placeholder={t('postcode')}
                style={{ maxWidth: 100 }}
                error={!!errors.postcode}
                inputRef={ref}
                inputProps={{
                  inputMode: 'numeric',
                  maxLength: 5,
                }}
              />
              {!!errors.postcode && <ErrorMessage>{errors.postcode.message}</ErrorMessage>}
            </div>
          </InputWrapper>
        </QuestionMark>

        <ButtonWrapper>
          <SubmitButton onClick={handleSubmit}>{t('continue')}</SubmitButton>
          <Information>{t('enter')}</Information>
        </ButtonWrapper>
      </div>
    </MainLayout>
  );
};

export default Postcode;
